import { getBlob, getStorage, ref } from 'firebase/storage'
import { saveAs } from 'file-saver'
import { kGcsArtifactsBucketRef } from '@/constants/constants-gcs'

const kDefaultDownloadFilename = 'download.docx'

export async function downloadArtifactObjectPath(objectPath: string, filename?: string): Promise<void> {
  const storage = getStorage(undefined, kGcsArtifactsBucketRef)
  const blob = await getBlob(ref(storage, objectPath))
  saveAs(blob, filename ?? objectPath.split('/').pop() ?? kDefaultDownloadFilename)
}
